<template>
  <div>
    <div class="flex flex-row bg-grey-100 px-1 sm:px-3 py-6">
      <!-- Filters -->
      <div class="bg-grey-50 border border-grey-200 rounded-lg pt-6 px-2 w-2/5 md:w-1/5 filter-height">
        <div class="flex flex-col w-full sm:px-2 mb-4">
          <label class="font-semibold text-md text-grey-700 mb-2">
            {{ $t('frontend_search') }}
          </label>
          <text-input
            class="inline-block mr-2"
            variant="base"
            v-model="search_name"
            v-debounce:1s="changedSearch"
            :debounce-events="['input', 'keyup']"
            :placeholder="$t('frontend_search')"
          >
            <SearchIcon slot="prependIcon"/>
          </text-input>
        </div>

        <VuePerfectScrollbar
          class="flex flex-col w-full"
          :style="{
            height: filtersHeight,
            maxHeight: '100%',
          }"
        >
          <gd-accordion
            ref="categoriesRef"
            v-if="categories && categories.length"
          >
            <template #title="slotProps">
              <p class="inline-flex items-center text-grey-700 font-semibold">
                <span class="mr-2 text-sm md:text-base">
                  {{ $t('frontend_groovemail_admin_global_templates_categories_header') }}
                </span>
                <span
                  v-if="filtersApplied.categories.length"
                  class="border rounded-full px-2 mr-2"
                  :class="{
                    'bg-primary border-white text-primary-invert':
                      filtersApplied.categories.length,
                    'bg-white': !filtersApplied.categories.length,
                  }"
                >
                  {{ filtersApplied.categories.length }}
                </span>
                <ArrowDown
                  v-show="!slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
                <ArrowUp
                  v-show="slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
              </p>
            </template>
            <div>
              <gd-checkbox
                v-for="(category, idx) in categories"
                :key="idx"
                v-model="category.selected"
                variant="primary"
                :label="category.name"
                labelClass="font-semibold self-center text-xs sm:text-sm text-grey-700"
                size="md"
                class="mb-4"
                @change="filterSelected(1, category)"
              ></gd-checkbox>
            </div>
          </gd-accordion>

          <gd-accordion
            ref="usagesRef"
            class="mt-2"
            v-if="usages && usages.length"
          >
            <template #title="slotProps">
              <p class="inline-flex items-center text-grey-700 font-semibold">
                <span class="mr-2 text-sm md:text-base">
                  {{ $t('frontend_groovemail_befree_email_builder_template_selector_usages') }}
                </span>
                <span
                  v-if="filtersApplied.usages.length"
                  class="border rounded-full px-2 mr-2"
                  :class="{
                    'bg-primary border-white text-primary-invert':
                      filtersApplied.usages.length,
                    'bg-white': !filtersApplied.usages.length,
                  }"
                >
                  {{ filtersApplied.usages.length }}
                </span>
                <ArrowDown
                  v-show="!slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
                <ArrowUp
                  v-show="slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
              </p>
            </template>
            <div>
              <gd-checkbox
                v-for="(category, idx) in usages"
                :key="idx"
                v-model="category.selected"
                variant="primary"
                :label="category.name"
                labelClass="font-semibold self-center text-sm text-grey-700"
                size="md"
                class="mb-4"
                @change="filterSelected(2, category)"
              ></gd-checkbox>
            </div>
          </gd-accordion>

          <gd-accordion
            ref="automatedRef"
            class="mt-2"
            v-if="automated_types && automated_types.length"
          >
            <template #title="slotProps">
              <p class="inline-flex items-center text-grey-700 font-semibold">
                <span class="mr-2 text-sm md:text-base">
                  {{ $t('frontend_groovemail_befree_email_builder_template_selector_automated') }}
                </span>
                <span
                  v-if="filtersApplied.automated_types.length"
                  class="border rounded-full px-2 mr-2"
                  :class="{
                    'bg-primary border-white text-primary-invert':
                      filtersApplied.automated_types.length,
                    'bg-white': !filtersApplied.automated_types.length,
                  }"
                >
                  {{ filtersApplied.automated_types.length }}
                </span>
                <ArrowDown
                  v-show="!slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
                <ArrowUp
                  v-show="slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
              </p>
            </template>
            <div>
              <gd-checkbox
                v-for="(category, idx) in automated_types"
                :key="idx"
                v-model="category.selected"
                variant="primary"
                :label="category.name"
                labelClass="font-semibold self-center text-sm text-grey-700"
                size="md"
                class="mb-4"
                @change="filterSelected(3, category)"
              ></gd-checkbox>
            </div>
          </gd-accordion>

          <gd-accordion
            ref="seasonsRef"
            class="mt-2"
            v-if="seasons && seasons.length"
          >
            <template #title="slotProps">
              <p class="inline-flex items-center text-grey-700 font-semibold">
                <span class="mr-2 text-sm md:text-base">
                  {{ $t('frontend_groovemail_befree_email_builder_template_selector_seasonal') }}
                </span>
                <span
                  v-if="filtersApplied.seasons.length"
                  class="border rounded-full px-2 mr-2"
                  :class="{
                    'bg-primary border-white text-primary-invert':
                      filtersApplied.seasons.length,
                    'bg-white': !filtersApplied.seasons.length,
                  }"
                >
                  {{ filtersApplied.seasons.length }}
                </span>
                <ArrowDown
                  v-show="!slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
                <ArrowUp
                  v-show="slotProps.isOpen"
                  class="h-5 w-5 fill-current"
                />
              </p>
            </template>
            <div>
              <gd-checkbox
                v-for="(category, idx) in seasons"
                :key="idx"
                v-model="category.selected"
                variant="primary"
                :label="category.name"
                labelClass="font-semibold self-center text-sm text-grey-700"
                size="md"
                class="mb-4"
                @change="filterSelected(4, category)"
              ></gd-checkbox>
            </div>
          </gd-accordion>
        </VuePerfectScrollbar>
      </div>
      <div class="w-3/5 md:w-4/5">
        <div class="text-sm font-semibold gm-template-selection-grid">
          <template-selection-grid
            ref="templateGrid"
            :url="url"
            :showOnlyGlobal="showOnlyGlobal"
            :search="searchFilter"
            :filters="filtersApplied"
            :templatesHeight="templatesHeight"
            :gridView="gridView"
            @selectedTemplate="selectedTemplate"
            @editTemplate="editTemplate"
            @renameTemplate="renameTemplate"
            @cloneTemplate="cloneTemplate"
            @deleteTemplate="deleteTemplate"
          >
          </template-selection-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import TemplateSelectionGrid from '@groovepages/gd-ui-kit/components/TemplateSelectionGrid';
import GdAccordion from '@groovepages/gd-ui-kit/components/Accordion';
import themeConfig from '@/theme/themeConfig';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import ArrowDown from '@/assets/images/icons/new/down_new.svg';
import ArrowUp from '@/assets/images/icons/new/up_arrow_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';

export default {
  middleware: 'auth',

  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_befree_email_builder_template_selector_title'),
    };
  },

  props: {
    url: {
      required: true,
    },
    tabType: {
      required: true,
      default: 'global',
    },
    showOnlyGlobal: {
      required: false,
    },
    filtersHeight: {
      required: false,
      default: 'calc(100vh - 260px)',
    },
    templatesHeight: {
      required: false,
      default: 'calc(100vh - 120px)',
    },
    gridView: {
      required: false,
      default: true,
    },
  },

  components: {
    VuePerfectScrollbar,
    TemplateSelectionGrid,
    GdAccordion,
    ArrowDown,
    ArrowUp,
    SearchIcon,
  },

  data() {
    return {
      search_name: '',
      searchFilter: '',
      categories: [],
      seasons: [],
      automated_types: [],
      usages: [],
      filtersApplied: {
        categories: [],
        seasons: [],
        automated_types: [],
        usages: [],
        total: 0,
      },
    };
  },

  async mounted() {
    await this.fetchFilters();
    if (this.$refs.categoriesRef) {
      this.$refs.categoriesRef.isOpen = true;
    }
  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader() {
      this.$emit('hideLoader');
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: var(--brand-primary-invert) !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    selectedTemplate(templateId) {
      this.$emit('selectedTemplate', templateId);
    },

    editTemplate(templateId) {
      this.$emit('editTemplate', templateId);
    },

    renameTemplate(templateId){
      this.$emit('renameTemplate',templateId);
    },
    
    cloneTemplate(template) {
      this.$emit('cloneTemplate', template);
    },

    deleteTemplate(templateId) {
      this.$emit('deleteTemplate', templateId);
    },

    async fetchFilters() {
      this.initializeFilters();
      if (this.tabType === 'global') {
        try {
          this.showLoader();
          const filterData = await axios.get(`/filter/all`);
          this.createFiltersForGlobalTab(
            filterData.data ? filterData.data : null
          );
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      } else {
        try {
          this.showLoader();
          const filterData = await axios.get(`/user-template-folders`);
          this.createFiltersForRest(filterData.data ? filterData.data : null);
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }
    },

    initializeFilters() {
      this.search_name = '';
      this.searchFilter = '';
      this.categories = [];
      this.automated_types = [];
      this.usages = [];
      this.seasons = [];
      this.filtersApplied = {
        categories: [],
        seasons: [],
        automated_types: [],
        usages: [],
        total: 0,
      };
      // if (this.$refs && this.$refs.templateGrid) {
      //   this.$refs.templateGrid.resetSearch();
      // }
    },

    createFiltersForGlobalTab(filters) {
      if (filters) {
        if (
          filters.automated &&
          filters.automated.data &&
          filters.automated.data.length
        ) {
          this.automated_types = filters.automated.data;
        }
        if (
          filters.category &&
          filters.category.data &&
          filters.category.data.length
        ) {
          this.categories = filters.category.data;
        }
        if (
          filters.seasons &&
          filters.seasons.data &&
          filters.seasons.data.length
        ) {
          this.seasons = filters.seasons.data;
        }
        if (filters.usage && filters.usage.data && filters.usage.data.length) {
          this.usages = filters.usage.data;
        }
      }
    },

    createFiltersForRest(filters) {
      if (filters && filters.data && filters.data.length) {
        this.categories = filters.data;
      }
    },

    changedSearch(newVal) {
      this.searchFilter = newVal;
    },

    // This function updates the filtersApplied object based on the selected filter
    filterSelected(type, filter) {
      // show loader
      this.showLoader();
      
      // Define a helper function to validate and modify the filter type array
      const modifyFilterTypeArray = (filterTypeArray) => {
        if (filter.selected) {

          // If the filter is selected, add it to the filter type array if it is not already present
          const filterPresent = filterTypeArray.find((ele) => ele === filter.id);
          if (!filterPresent) {
            filterTypeArray.push(filter.id);
          }
        } else {
          // If the filter is not selected, remove it from the filter type array if it is present
          const filterIndex = filterTypeArray.findIndex((ele) => ele === filter.id);
          if (filterIndex >= 0) {
            filterTypeArray.splice(filterIndex, 1);
          }
        }
      };

      // Use the helper function to modify the appropriate filter type array based on the type parameter
      if (type === 1) {
        modifyFilterTypeArray(this.filtersApplied.categories);
      } else if (type === 2) {
        modifyFilterTypeArray(this.filtersApplied.usages);
      } else if (type === 3) {
        modifyFilterTypeArray(this.filtersApplied.automated_types);
      } else if (type === 4) {
        modifyFilterTypeArray(this.filtersApplied.seasons);
      }

      // Update the total number of filters applied
      this.filtersApplied.total =
        this.filtersApplied.categories.length +
        this.filtersApplied.usages.length +
        this.filtersApplied.automated_types.length +
        this.filtersApplied.seasons.length;
        
      // hide loader
      this.hideLoader();
    },

  },
};
</script>

<style lang="scss">
.gm-template-selection-grid {
  aside {
    display: none;
  }
  main {
    width: 100% !important;
  }
}
</style>
